import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export interface IMapModalMobileHeaderProps {
  backTestId?: string;
  /** Кнопка справа от заголовка — например, «В избранное». */
  rightSlot?: React.ReactNode;
  testId?: string;
  title: string;
  onBack(): void;
}

/** Мобильная шапка модалки с картой: стрелка «назад» вместо крестика, заголовок по центру. */
export function MapModalMobileHeader({
  backTestId,
  rightSlot,
  testId,
  title,
  onBack,
}: IMapModalMobileHeaderProps): React.JSX.Element {
  return (
    <div className={styles['container']} data-testid={testId}>
      <button aria-label="Назад" className={styles['back']} data-testid={backTestId} type="button" onClick={onBack}>
        <IconActionArrowLeft24 color="icon-main-default" />
      </button>
      <div className={styles['title']}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      {/* Пустая заглушка сохраняет заголовок по центру, когда кнопки справа нет. */}
      {rightSlot ?? <div className={styles['stub']} />}
    </div>
  );
}
